import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    useEffect(() => {}, []);
    const { t } = useTranslation();

    return (
        <footer className="footer-wrapper">
            <div className="inner">
                <h2 className="ft_logo">aw</h2>
                <ul className="ft_menu">
                    <li>
                        <Link to="/service">{t('이용약관')}</Link>
                    </li>
                    <li className="policy">
                        <Link to="/policy">{t('개인정보처리방침')}</Link>
                    </li>
                </ul>
                <address className="t_addr">{t('광주광역시 북구 추암로 249 (광주테크노파크 치매기술실증센터 209호)')}</address>
                <address className="b_addr">
                    <span>{t('(주)오토웰즈')}</span>
                    <span>{'T. 062 . 372 . 3731'}</span>
                    <span>{'F. 062 . 372 . 3735'}</span>
                    <span>{t('E. office@autowells.co.kr')}</span>
                    <span>Copyright 2020. AUTOWELLS CO.,LTD. All rights reserved.</span>
                </address>
            </div>
        </footer>
    );
};

export default Footer;
